// Utils
import { cdnUri } from '@nerdwallet/nw-client-lib/cdn';

const imgUri = cdnUri('img/diy/hac', 'png');
const image = imgUri('house-slider-bg-score');

export default [
  {
    image,
    copy: 'Afford your dream home! NerdWallet will help you get there.',
  },
  {
    image,
    copy: 'NerdWallet identifies savings on bills to reach down payment faster.',
  },
];
